<template>
    <div class="container py-5">
        <!-- Encabezado -->
        <div class="mb-4">
            <h2 class="fw-bold">Crea y registra</h2>
            <p class="mb-1">Ingresa los datos que pide a continuación.</p>
            <a href="#" class="fw-bold">¿Ya tienes tu mesa registrada? Entrar a mi mesa</a>
        </div>

        <!-- Paso a paso -->
        <div class="stepper">
            <div v-for="value in 5" :key="value" class="step" v-bind:class="{ active: vista === value }"
                @click="cambiarVista(value)">{{ value }}</div>
        </div>

        <!-- Contenido -->

        <div class="card-custom" v-if="vista === 1">
            <h5 class="fw-semibold mb-3">Selecciona tu celebración</h5>
            <br>
            <label for="celebracion" class="form-label fw-semibold">Selecciona tu celebración</label>
            <select id="celebracion" class="form-select" v-model="formData.celebracion"
                placeholder="Selecciona una opción">
                <option selected disabled>Selecciona una opción</option>
                <option value="boda">Boda</option>
                <option value="cumple">Cumpleaños</option>
                <option value="bautizo">Bautizo</option>
                <option value="xv años">XV años</option>
                <option value="otros">Otros</option>
            </select>
            <center>
                <button type="button" class="btn btn-primary text-light mt-3" @click="cambiarVista(2)">Continuar <i
                        class="fa-solid fa-arrow-right"></i></button>
            </center>
        </div>

        <div class="card-custom" v-if="vista === 2">
            <h5 class="fw-semibold mb-3">Datos de los festejados</h5>
            <br>
            <div class="mb-3">
                <label for="" class="form-label">Nombre</label>
                <input type="text" class="form-control" name="" id="" v-model="formData.nombre"
                    aria-describedby="helpId" placeholder="Nombre" />
            </div>
            <div class="mb-3">
                <label for="" class="form-label">Apellido paterno</label>
                <input type="text" class="form-control" name="" id="" v-model="formData.apellidoPaterno"
                    aria-describedby="helpId" placeholder="Apellido paterno" />
            </div>
            <div class="mb-3">
                <label for="" class="form-label">Apellido materno</label>
                <input type="text" class="form-control" name="" id="" v-model="formData.apellidoMaterno"
                    aria-describedby="helpId" placeholder="Apellido materno" />
            </div>
            <div class="mb-3">
                <label for="" class="form-label">Fecha de naciemiento</label>
                <input type="date" class="form-control" name="" id="" v-model="formData.fechaNacimiento"
                    aria-describedby="helpId" placeholder="Fecha de naciemiento" />
            </div>
            <div class="mb-3">
                <label for="" class="form-label">Whatsapp</label>
                <input type="number" class="form-control" name="" id="" v-model="formData.whatsapp"
                    aria-describedby="helpId" placeholder="Whatsapp" />
            </div>
            <center>
                <button type="button" class="btn btn-primary text-light mt-3" @click="cambiarVista(3)">Continuar <i
                        class="fa-solid fa-arrow-right"></i></button>
            </center>
        </div>

        <div class="card-custom" v-if="vista === 3">
            <h5 class="fw-semibold mb-3">Ingresa los datos del evento</h5>
            <br>
            <div class="mb-3">
                <label for="" class="form-label">Fecha del evento</label>
                <input type="date" class="form-control" name="" id="" v-model="formData.fechaEvento"
                    aria-describedby="helpId" placeholder="Fecha del evento" />
            </div>
            <div class="mb-3">
                <label for="" class="form-label">Nombre del evento</label>
                <input type="text" class="form-control" name="" id="" v-model="formData.nombreEvento"
                    aria-describedby="helpId" placeholder="Nombre del evento" />
            </div>
            <div class="mb-3">
                <label for="" class="form-label">Imágen del evento</label>
                <input type="file" class="form-control" name="" id="" @change="capturarImagen" aria-describedby="helpId"
                    placeholder="" />
            </div>
            <div class="mb-3">
                <label for="" class="form-label">Correo electronico</label>
                <input type="mail" class="form-control" name="" id="" v-model="formData.correoElectronico"
                    aria-describedby="helpId" placeholder="Correo electronico" />
            </div>
            <center>
                <button type="button" class="btn btn-primary text-light mt-3" @click="cambiarVista(4)">Continuar <i
                        class="fa-solid fa-arrow-right"></i></button>
            </center>
        </div>

        <div class="card-custom" v-if="vista === 4">
            <h5 class="fw-semibold mb-3">Selecciona el paquete</h5>
            <br>
            <label for="celebracion" class="form-label fw-semibold">Paquete</label>

            <v-select v-model="formData.paquete" :options="options" :reduce="option => option.value" label="label"
                placeholder="Selecciona un paquete" />
            <center>
                <button type="button" class="btn btn-primary text-light mt-3" @click="cambiarVista(5)">Continuar <i
                        class="fa-solid fa-arrow-right"></i></button>
            </center>
        </div>

        <div class="card-custom" v-if="vista === 5">
            <h5 class="fw-semibold mb-3">Contrato de mesa de regalos</h5>
            <br>
            <label for="celebracion" class="form-label fw-semibold">Puedes consultar el contrato en el momento que
                necesites desde tú cuenta de mesa de regalos</label>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="" v-model="formData.aceptaTerminos" />
                <label class="form-check-label" for=""> Acepto los términos y condiciones del servicio, así como los
                    establecidos en el contrato </label>
            </div>
            <center>
                <button type="button" class="btn btn-primary text-light mt-3" @click="enviarFormulario">Continuar <i
                        class="fa-solid fa-arrow-right"></i></button>
            </center>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import vSelect from "vue3-select";
import Swal from "sweetalert2";
import "vue3-select/dist/vue3-select.css";
const token = localStorage.getItem("token")
export default {
    name: "GifTableDash",
    data() {
        return {
            vista: 1,
            formData: {
                idUser: null,
                celebracion: "Selecciona una opción",
                nombre: "",
                apellidoPaterno: "",
                apellidoMaterno: "",
                fechaNacimiento: "",
                whatsapp: "",
                fechaEvento: "",
                nombreEvento: "",
                imagenEvento: null,
                correoElectronico: "",
                paquete: "Selecciona una opción",
                aceptaTerminos: false,
            },
            options: ["Opción 1", "Opción 2", "Opción 3"],
        };
    },
    components: {
        vSelect,
    },
    methods: {
        capturarImagen(event) {
            const file = event.target.files[0];
            this.formData.imagenEvento = file;
        },
        cambiarVista(nuevaVista) {
            this.vista = nuevaVista;
        },
        validarCampos() {
            // Aquí puedes agregar la lógica para validar los campos del formulario
            // Por ejemplo, verificar que los campos obligatorios no estén vacíos
            if (this.formData.celebracion === "Selecciona una opción") {
                alert("Por favor, selecciona una celebración.");
                return false;
            }
            if (!this.formData.nombre || !this.formData.apellidoPaterno || !this.formData.apellidoMaterno) {
                alert("Por favor, completa todos los campos de nombre.");
                return false;
            }
            if (!this.formData.fechaNacimiento) {
                alert("Por favor, ingresa una fecha de nacimiento.");
                return false;
            }
            if (!this.formData.whatsapp) {
                alert("Por favor, ingresa un número de Whatsapp.");
                return false;
            }
            if (!this.formData.fechaEvento) {
                alert("Por favor, ingresa la fecha del evento.");
                return false;
            }

            if (!this.formData.nombreEvento) {
                alert("Por favor, ingresa el nombre del evento.");
                return false;
            }
            if (!this.formData.imagenEvento) {
                alert("Por favor, selecciona una imagen para el evento.");
                return false;
            }
            if (!this.formData.correoElectronico) {
                alert("Por favor, ingresa un correo electrónico.");
                return false;
            }
            if (this.formData.paquete === "Selecciona una opción") {
                alert("Por favor, selecciona un paquete.");
                return false;
            }
            if (!this.formData.aceptaTerminos) {
                alert("Por favor, acepta los términos y condiciones.");
                return false;
            }
            // Agrega más validaciones según sea necesario
            return true; // Si todo está bien, retorna true
        },

        async traerPaquetes() {
            try {
                const response = await axios.get("https://beauvoyage.net/api/paquetes", {
                    headers: {
                        "Authorization": `Bearer ${token}`,

                    }
                })
                this.options = response.data.map(paquete => ({
                    label: paquete.nombre, // lo que ve el usuario
                    value: paquete.id      // el valor numérico que quieres enviar
                }));
                console.log(this.options);
            } catch {
                console.log("Error al traer los paquetes");
            }
        },
        async enviarFormulario() {
            if (this.validarCampos()) {
                const formData = new FormData();

                formData.append("celebracion", this.formData.celebracion);
                formData.append("nombre", this.formData.nombre);
                formData.append("apellidoPaterno", this.formData.apellidoPaterno);
                formData.append("apellidoMaterno", this.formData.apellidoMaterno);
                formData.append("fechaNacimiento", this.formData.fechaNacimiento);
                formData.append("whatsapp", this.formData.whatsapp);
                formData.append("fechaEvento", this.formData.fechaEvento);
                formData.append("nombreEvento", this.formData.nombreEvento);
                formData.append("correoElectronico", this.formData.correoElectronico);
                formData.append("paquete", this.formData.paquete);
                formData.append("idUser", this.formData.idUser);
                // ✅ Solo agregamos si está marcado
                if (this.formData.aceptaTerminos) {
                    formData.append("aceptaTerminos", "1");
                }

                // ✅ Solo agregamos si hay archivo
                if (this.formData.imagenEvento) {
                    formData.append("imagenEvento", this.formData.imagenEvento);
                }

                console.log(formData);

                try {
                    const res = await axios.post("https://beauvoyage.net/api/crearMesa", formData, {
                        headers: { "Content-Type": "multipart/form-data" },
                    });
                    console.log(res.data);
                    Swal.fire({
                        icon: 'success',
                        title: 'Mesa creada',
                        text: 'La mesa de regalos ha sido creada exitosamente.',
                        confirmButtonText: 'Aceptar'
                    });
                    // Aquí puedes redirigir al usuario o limpiar el formulario
                    this.$router.push("/Dashboard");
                } catch (err) {
                    console.error(err.response?.data || err);
                }
            }
        },
        async getDataUser() {
            const token = localStorage.getItem("token")
            try {
                const response = await axios.get("https://beauvoyage.net/api/v1/auth/me", {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                this.formData.idUser = response.data.id;
                console.log(this.formData.idUser);
                
            } catch (error) {
                console.log(error);
            }
        }

    },
    created() {
        this.traerPaquetes();
        this.getDataUser();
    }
};
</script>
<style>
.stepper {
    display: flex;
    justify-content: space-between;
    margin: 2rem 0;
    position: relative;
}

.stepper::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 4px;
    background: #ddd;
    transform: translateY(-50%);
    z-index: 0;
}

.step {
    position: relative;
    z-index: 1;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    background: #ddd;
    color: #fff;
}

.step.active {
    background: #ea7f2f;
}

.card-custom {
    border-radius: 1rem;
    padding: 2rem;
    background: #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
</style>